// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@property --async-button-angle {
  syntax: '<angle>';
  inherits: false;
  initial-value: 0deg;
}

.async-button {
  --async-button-glint-color: currentColor;
  position: relative;
  isolation: isolate;
  overflow: hidden;
}

.async-button__sizer {
  display: inline-grid;
  align-items: center;
  justify-items: center;
}

.async-button__content,
.async-button__loading {
  grid-area: 1 / 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.35rem;
}

.async-button:not([data-loading='true']) .async-button__loading,
.async-button[data-loading='true'] .async-button__content {
  visibility: hidden;
}

.async-button:disabled:not([data-loading='true']) {
  cursor: not-allowed;
  opacity: 0.65;
}

.async-button[data-loading='true'] {
  cursor: not-allowed;
}

.async-button[data-loading='true']::after {
  content: '';
  position: absolute;
  z-index: 2;
  inset: 0;
  padding: 2px;
  border-radius: inherit;
  pointer-events: none;
  background: conic-gradient(
    from var(--async-button-angle),
    transparent 0deg 300deg,
    var(--async-button-glint-color) 326deg,
    transparent 352deg 360deg
  );
  -webkit-mask:
    linear-gradient(#000 0 0) content-box,
    linear-gradient(#000 0 0);
  -webkit-mask-composite: xor;
  mask-composite: exclude;
  animation: async-button-edge-glint 1.45s linear infinite;
}

@keyframes async-button-edge-glint {
  to {
    --async-button-angle: 360deg;
  }
}

@media (prefers-reduced-motion: reduce) {
  .async-button[data-loading='true']::after {
    --async-button-angle: 326deg;
    animation: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/AsyncButton.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,wCAAwC;EACxC,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;EAEE,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,YAAY;EACZ,sBAAsB;EACtB,oBAAoB;EACpB;;;;;GAKC;EACD;;6BAE2B;EAC3B,2BAA2B;EAC3B,uBAAuB;EACvB,wDAAwD;AAC1D;;AAEA;EACE;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,4BAA4B;IAC5B,eAAe;EACjB;AACF","sourcesContent":["@property --async-button-angle {\n  syntax: '<angle>';\n  inherits: false;\n  initial-value: 0deg;\n}\n\n.async-button {\n  --async-button-glint-color: currentColor;\n  position: relative;\n  isolation: isolate;\n  overflow: hidden;\n}\n\n.async-button__sizer {\n  display: inline-grid;\n  align-items: center;\n  justify-items: center;\n}\n\n.async-button__content,\n.async-button__loading {\n  grid-area: 1 / 1;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.35rem;\n}\n\n.async-button:not([data-loading='true']) .async-button__loading,\n.async-button[data-loading='true'] .async-button__content {\n  visibility: hidden;\n}\n\n.async-button:disabled:not([data-loading='true']) {\n  cursor: not-allowed;\n  opacity: 0.65;\n}\n\n.async-button[data-loading='true'] {\n  cursor: not-allowed;\n}\n\n.async-button[data-loading='true']::after {\n  content: '';\n  position: absolute;\n  z-index: 2;\n  inset: 0;\n  padding: 2px;\n  border-radius: inherit;\n  pointer-events: none;\n  background: conic-gradient(\n    from var(--async-button-angle),\n    transparent 0deg 300deg,\n    var(--async-button-glint-color) 326deg,\n    transparent 352deg 360deg\n  );\n  -webkit-mask:\n    linear-gradient(#000 0 0) content-box,\n    linear-gradient(#000 0 0);\n  -webkit-mask-composite: xor;\n  mask-composite: exclude;\n  animation: async-button-edge-glint 1.45s linear infinite;\n}\n\n@keyframes async-button-edge-glint {\n  to {\n    --async-button-angle: 360deg;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .async-button[data-loading='true']::after {\n    --async-button-angle: 326deg;\n    animation: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
